// extracted by mini-css-extract-plugin
export default {"label":"Label_label__7pwID","text":"Label_text__zWGuL","required":"Label_required__l8RJn","labelRtl":"Label_labelRtl__0fzH0","secondary":"Label_secondary__KCF8m"};